import cx from 'classnames';
import styled from 'styled-components';
import voca from 'voca';
import { isNumber } from 'lodash';
import './SvgIcon.scss';

const StyledIcon = styled.div
  .withConfig({ shouldForwardProp: (prop) => !['extClassName', 'size', 'colorName'].includes(prop) })
  .attrs(({ onClick, size, extClassName, colorName }) => ({
    className: cx('dib', extClassName, {
      'w-100 h-100': !size,
      pointer: onClick,
      [`box-${size || ''}`]: voca.isString(size),
      [`fill-${colorName || ''}`]: voca.isString(colorName),
    }),
  }))(({ size, style }) => ({
  ...style,
  width: isNumber(size) ? size : null,
  height: isNumber(size) ? size : null,
}));

const SvgIcon = ({ path, fill, className, colorName, size, color, onClick, title, style, dataTest }) => (
  <StyledIcon onClick={onClick} size={size} extClassName={className} colorName={colorName} style={style} title={title} data-test={dataTest}>
    <svg className="db" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid" style={{ fill: fill || color }}>
      <path d={path} />
    </svg>
  </StyledIcon>
);

SvgIcon.defaultProps = {
  fill: '',
};

export default SvgIcon;
